import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AlertNotification from "../../../../app/src/Components/GUI/Alert/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import "./EPG.css";
import {
  turnOffLoadingActionCreator,
  turnOnLoadingActionCreator,
} from "../../../../app/src/actions/commonActions";
import { useKeycloak } from "@react-keycloak/web";
import {
  URL_BASE_V2,
} from "../../../../app/src/services/servicesConstants";
import {getToken} from "../../../../app/src/Utils/utils";
import i18n from "../../../../app/src/i18n";
import { isCordovaAvailable } from "../../../../app/src/Utils/secureStorageUtil";
import {
  TENANT,
} from "../../../../app/src/Resources/Multitenant/tenantConstants";

function EPG() {
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const history = useHistory();
  const { t } = useTranslation();
  const userToken = getToken(keycloak);
  const baseUrl = URL_BASE_V2;

  const languageSelected = useSelector((state) => state.commonState.languageSelected) || i18n.language;

  const [epgUrl, setEpgUrl] = useState(null);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [timeoutError, setTimeoutError] = useState(false);
  const iframeRef = useRef(null);

  const turnOnLoading = () => {
    dispatch(turnOnLoadingActionCreator());
  };

  const turnOffLoading = () => {
    dispatch(turnOffLoadingActionCreator());
  };

  useEffect(() => {
    turnOnLoading();
    

    let epgApiUrl = `${baseUrl}player/epg/${TENANT}`;

    if (isCordovaAvailable()) {
      epgApiUrl = `${epgApiUrl}?device=android&`;
    }

    const params = new URLSearchParams();
 
    params.append('language', languageSelected);

    if (!!userToken) {
      params.append('token', userToken);
    }

    const currentUrlParams = new URLSearchParams(window.location.search);
    currentUrlParams.forEach((value, key) => {
      if (key !== 'language' && key !== 'token') {
        params.append(key, value);
      }
    });

    if (!!params.toString()) {
      epgApiUrl = `${epgApiUrl}${epgApiUrl.includes('?') ? '&' : '?'}${params.toString()}`;
    }

    setEpgUrl(epgApiUrl);
  }, [userToken, languageSelected, baseUrl]);

  useEffect(() => {
    if (!!epgUrl) {
      turnOffLoading();
    }
  }, [epgUrl]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (isLoading) {
        setTimeoutError(true);
        setIsLoading(false);
      }
    }, 20000);

    return () => clearTimeout(timeout);
  }, [isLoading]);

  const actionToLoaded = () => {
    setTimeoutError(false);
    setIsLoading(false);
  };

  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.onload = () => actionToLoaded();
      iframeRef.current.onerror = () => {
        setIsLoading(false);
        setError(true);
        setTimeoutError(true);
      };
    }
  }, [epgUrl]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && typeof event.data === 'object') {
        const { type, id } = event.data;
        
        if (type === 'videodetail' && id) {
          history.push(`/videodetail/${id}`);
        } else if (type === 'player' && id) {
          history.push(`/player/${id}`);
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [history]);

  return (
    <>
      {isLoading && (
        <div className="spinner">
          <CircularProgress size={50} thickness={4} />
        </div>
      )}
      {timeoutError && (
        <div className="error-modal">
          <p>{t("epg.error.message")}</p>
          <button onClick={() => window.location.reload()}>{t("epg.error.retry")}</button>
        </div>
      )}
        {epgUrl && (
          <iframe
            ref={iframeRef}
            src={epgUrl}
            className="EPGIframe"
            allow="autoplay; encrypted-media; fullscreen; keyboard *"
            id="epg"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowfullscreen="true"
          />
        )}
      {error && <AlertNotification />}
    </>
  );
}

export default EPG;
